import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AnnouncementBoxUI from './announcement-box-ui';
import AnnouncementBoxEditing from './announcement-box-editing';
import CustomImageAlternativeTextUI from "../blocks/custom-image-alternative-text-ui";
export default class AnnouncementBox extends Plugin {
  static get requires() {
      return [ AnnouncementBoxEditing, AnnouncementBoxUI, CustomImageAlternativeTextUI ];
  }
}
